<script setup lang="ts">
// Who receives the profile, as a labelled tag. The label was assembled by hand (so it stayed English
// in a German UI) and BOTH was shown in red `danger`, which reads as an error for a perfectly normal
// setting; `warning` was also not a valid PrimeVue v4 severity. Three distinct, non-alarming colours now.
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
    recipients: {
        type: String,
        required: true,
    },
});

const { t, te } = useI18n();

type TagSeverity = "info" | "warn" | "success" | "secondary";

const SEVERITY: Record<string, TagSeverity> = {
    TRAINER: "info",
    PARTICIPANT: "warn",
    BOTH: "success",
};

const severity = computed<TagSeverity>(() => SEVERITY[props.recipients] ?? "secondary");
const label = computed(() => {
    const key = `projects.recipientType.${props.recipients}`;
    return te(key) ? t(key) : props.recipients;
});
</script>

<template>
    <Tag :value="label" :severity="severity" style="font-weight: normal" />
</template>
